import styled from 'styled-components';
import {dFlex, dInlineFlex, alignCenter, justifyCenter, justifyEnd, flexWrap, dFlexColumn} from '../../../../../globalVariables/GlobalFlex';
import {mobileMedia} from '../../../../../globalVariables/GlobalVariables';
import {Form} from 'formik';


export const form = styled(Form)`
    ${dFlexColumn};
    gap: var(--space-xl);
    overflow-y: auto;
    max-height: calc(90vh - 212px);
    padding: var(--space-xl) var(--space-lg);
`;
export const headerEnd = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-md);
`;

export const kebab = styled.button`
    background: transparent;
    border: none;
    cursor: pointer;
    padding: var(--space-xs);
    ${dInlineFlex}
    ${alignCenter}
    ${justifyCenter}
    color: var(--TA-color-text-subtle);
`;

export const footer = styled.div`
    ${dFlex}
    ${alignCenter}
    ${justifyEnd}
    gap: var(--space-lg);
    flex-shrink: 0;
    padding: var(--space-xl);
    border-top: 1px solid var(--color-border-subtle);
    background: var(--color-bg-base);
`;

export const card = styled.div`
    ${dFlexColumn}
    ${alignCenter}
    background: var(--TA-color-bg-surface-default);
    border-radius: var(--radius-lg);
    gap: var(--space-2xl);
    padding: var(--space-xl) var(--space-lg);
`;

export const imageWrap = styled.div`
    ${dFlex}
    ${justifyCenter}
    width: 100%;
`;

export const fields = styled.div`
    ${dFlexColumn}
    width: 100%;
`;

export const fieldRow = styled.div`
    ${dFlex}
    ${flexWrap}
    gap: var(--space-xl);
    width: 100%;

    > * {
        flex: 1 1 200px;
        min-width: 0;
    }

    ${mobileMedia} {
        gap: 0;
        flex-direction: column;

        > * {
            flex: 0 0 auto;
        }
    }
`;

export const aboutWrap = styled.div`
    ${dFlexColumn}
    gap: var(--space-xl);
    width: 100%;
`;

export const summaryField = styled.div`
    ${dFlexColumn}
    gap: var(--space-sm);
    width: 100%;
`;

export const summaryHeader = styled.div`
    ${dFlex}
    ${alignCenter}
    gap: var(--space-sm);
    width: 100%;
`;

export const summaryLabel = styled.span`
    font-weight: var(--font-weight-regular);
    font-size: var(--font-size-body);
    line-height: var(--line-height-body);
    color: var(--TA-color-text-default);
`;

export const summaryIcon = styled.span`
    ${dInlineFlex}
    ${alignCenter}
    ${justifyCenter}
    width: var(--space-xl);
    height: var(--space-xl);
    color: var(--TA-color-text-default);
`;

export const editorWrap = styled.div`
    width: 100%;
    .quill {
        background: var(--TA-color-bg-base);
    }
`;
